/* eslint-disable @typescript-eslint/no-explicit-any */
export function useVariables() {
  const authUrl: string | undefined = (window as any)._env_
    .REACT_APP_AUTH_API_URL;
  const appApiId: string | undefined = (window as any)._env_
    .REACT_APP_AUTH_APPLICATION_ID;
  const apiUrl: string | undefined = (window as any)._env_.REACT_APP_API_URL;
  const apiDemoUrl: string | undefined = (window as any)._env_
    .REACT_APP_API_DEMO_URL;
  const sdkApiKey: string | undefined = (window as any)._env_
    .REACT_APP_SDK_API_KEY;
  const demoBackend: string | undefined = (window as any)._env_
    .REACT_APP_DEMO_BACKEND;
  const appTesting: string | undefined =
    process.env.REACT_APP_TEST || (window as any)._env_.REACT_APP_TEST;

  return {
    apiUrl,
    authUrl,
    appApiId,
    apiDemoUrl,
    sdkApiKey,
    demoBackend,
    appTesting,
  };
}
